import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import HrbTranslate from '../language/HrbTranslate'

const ContentCard = ({ elementId, titleKey, titleParams, className, children }) => (
    <div id={elementId} className={classnames('content-card card is-shadowless', className)}>
        {titleKey &&
            <header className="card-header">
                <h3 className="card-header-title">
                    <HrbTranslate text={titleKey} params={titleParams} />
                </h3>
            </header>
        }
        <div className="card-content">
            <div className="content">
                {children}
            </div>
        </div>
    </div>
)

ContentCard.propTypes = {
    elementId: PropTypes.string.isRequired,
    titleKey: PropTypes.string,
    titleParams: PropTypes.object,
    className: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
}

export default ContentCard